import { render } from "./creators.vue?vue&type=template&id=38e4c90f&scoped=true"
import script from "./creators.vue?vue&type=script&lang=js"
export * from "./creators.vue?vue&type=script&lang=js"

import "./creators.vue?vue&type=style&index=0&id=38e4c90f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e4c90f"]])

export default __exports__